import React, { useEffect, useState } from 'react';
import { loginApi } from '../utils/api';
import { LOCAL_STORAGE_KEY } from '../constants';
import { useHistory } from 'react-router';

const Login = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const payLoad = {
      password,
      username,
      role: 'admin',
    };

    if (!payLoad.username || !payLoad.password) {
      alert('Please fill all fields');
      setIsLoading(false);
      return;
    }

    const { data, error } = await loginApi(payLoad);
    setIsLoading(false);

    if (data) {
      if (data.success) {
        if (data.user.role === 'admin') {
          localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data.user));
          setUsername('');
          setPassword('');
          history.push('/');
        }
      } else {
        alert('Invalid credentials');
      }
    } else {
      alert(error.message);
    }
  };

  useEffect(() => {
    const userInfo = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (userInfo) {
      history.push('/');
    }
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100%',
        backgroundImage:
          "url('https://images.unsplash.com/photo-1566073771259-6a8506099945')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      {/* Overlay */}
      <div
        style={{
          width: '100%',
          maxWidth: '1200px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(0,0,0,0.6)',
          borderRadius: '16px',
          padding: '30px 20px',
        }}
      >
        {/* Heading */}
        <p
          style={{
            fontSize: 'clamp(20px, 4vw, 32px)',
            color: '#fff',
            letterSpacing: '2px',
            marginBottom: '25px',
            textAlign: 'center',
          }}
        >
          <b>ADMIN PANEL</b>
        </p>

        {/* Card */}
        <div
          className="box box--login mt-4"
          style={{
            background: 'rgba(255,255,255,0.95)',
            borderRadius: '14px',
            padding: '25px',
            width: '100%',
            maxWidth: '380px',
            boxShadow: '0 15px 40px rgba(0,0,0,0.3)',
          }}
        >
          <div
            className="box__heading d-flex a-center j-center py-2"
            style={{
              fontWeight: '600',
              fontSize: '18px',
              marginBottom: '10px',
            }}
          >
            Welcome Admin
          </div>

          <form onSubmit={onSubmitHandler} className="form">
            {/* Username */}
            <div className="form__control">
              <label className="form__label">User Name</label>
              <input
                required
                disabled={isLoading}
                value={username}
                onChange={(e) => setUsername(e.target.value.trim())}
                className="form__input no-capital-input"
                type="text"
                placeholder="Enter username"
                style={{
                  borderRadius: '8px',
                  padding: '10px',
                  width: '100%',
                  marginTop: '5px',
                  boxSizing: 'border-box',
                  outline: 'none',
                  border: '1px solid #ccc',
                }}
              />
            </div>

            {/* Password */}
            <div className="form__control" style={{ marginTop: '15px' }}>
              <label className="form__label">Password</label>
              <input
                required
                disabled={isLoading}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form__input no-capital-input"
                type="password"
                placeholder="Enter password"
                style={{
                  borderRadius: '8px',
                  padding: '10px',
                  width: '100%',
                  marginTop: '5px',
                  boxSizing: 'border-box',
                  outline: 'none',
                  border: '1px solid #ccc',
                }}
              />
            </div>

            {/* Button */}
            <button
              disabled={isLoading}
              className="form__submit"
              style={{
                all: 'unset',
                marginTop: '20px',
                background:
                  'linear-gradient(135deg, #2c7be5, #1a5fd0)',
                color: '#fff',
                borderRadius: '8px',
                padding: '12px',
                cursor: 'pointer',
                width: '100%',
                textAlign: 'center',
                fontWeight: '600',
                fontSize: '15px',
                display: 'block',
              }}
            >
              {isLoading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>

        {/* Footer */}
        <footer
          className="footer d-flex j-center a-center p-3"
          style={{
            color: '#ddd',
            marginTop: '20px',
            fontSize: '12px',
            textAlign: 'center',
          }}
        >
          © 2026 Hotel Management System
        </footer>
      </div>
    </div>
  );
};

export default Login;
